var map = {
	"./Buckaroo.svg": 8404,
	"./Dropshipping.svg": 7359,
	"./Inventoro.svg": 4496,
	"./PSD2.svg": 2783,
	"./Shopify.svg": 2556,
	"./Shoptet.svg": 3513,
	"./Storyous.svg": 5760,
	"./Tanganica.svg": 1356,
	"./tax-form.svg": 5816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5194;